import { render, staticRenderFns } from "./Kharkov.vue?vue&type=template&id=744352bf"
import script from "./Kharkov.vue?vue&type=script&lang=js"
export * from "./Kharkov.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports